module.exports = __webpack_public_path__ + "static/media/LLNR_logo.483f9f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/LLNR_logo.png
// module id = 96
// module chunks = 0